import { render, staticRenderFns } from "./SaltoIqActivationSection.vue?vue&type=template&id=11facff0&scoped=true&"
import script from "./SaltoIqActivationSection.vue?vue&type=script&lang=js&"
export * from "./SaltoIqActivationSection.vue?vue&type=script&lang=js&"
import style0 from "./SaltoIqActivationSection.vue?vue&type=style&index=0&id=11facff0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11facff0",
  null
  
)

export default component.exports